import ValidationInterface from '@/plans/common/validation-interface';
import { basePlanCategories } from '@/common/persist-cart/categories';

export default class extends ValidationInterface {
  async requires() {
    return [this.current('translation_captions').require(basePlanCategories, { licenseMatch: false })];
  }

  async conflicts() {
    return this.current(['translation_captions']).conflict(['translation_captions']);
  }
}
